import APILibrary, { ClassExtender, GConstructor, GenerateResource } from './APILibrary';
import { Base } from 'active-resource';

/**
 * Relationship classes
 */
export class OpenAiLogAttributes {
  run_id?: string;
  request: string;
  response: string;
  extracted_text?: string;
  reason?: string;
  record_id: string;
  record_type?: string;
  job: string;
}

/**
 * Utility interfaces
 */
export interface OpenAiLogMethods {}

export interface OpenAiLogInterface extends OpenAiLogAttributes, OpenAiLogType {}

type OpenAiLogType = GConstructor<OpenAiLogInterface>;

export interface OpenAiLogResource
  extends Base<OpenAiLogAttributes>,
    OpenAiLogInterface,
    OpenAiLogMethods {}

/**
 * Resource methods
 */
const BaseClass = () =>
  GenerateResource<OpenAiLogAttributes>({
    queryName: 'open_ai_logs',
    className: 'OpenAiLog',
    AttributesClass: OpenAiLogAttributes,
  });

export const OpenAiLogResourceClass = <TBase extends OpenAiLogType>(BaseConstructor: TBase) =>
  class extends BaseConstructor implements OpenAiLogMethods {};

export class OpenAiLogResource extends ClassExtender<OpenAiLogInterface>(
  BaseClass,
  OpenAiLogResourceClass,
) {}

/**
 * Resource instance
 */
export const OpenAiLog = APILibrary.createResource<OpenAiLogResource>(OpenAiLogResource);
